// extracted by mini-css-extract-plugin
module.exports = {"letters":"letters_letters__vvjPR","hidden":"letters_hidden__8UW9B"};